import { connect } from 'react-redux';
import { getOperation, saveOperation } from '../../../store/actions/inputOperation';
import SemiProductsTable from './SemiProductsTable';
import { loadReadyProducts, saveReadyProducts, getReadyProductsBySemi, setSaveRequest } from '../../../store/actions/savedProducts';
import { getSemiProducts } from '../../../store/actions/semiProducts';
import { modalErrorOpen } from '../../../store/actions/modalError';

const mapStateToProps = ({
  userReducer,
  tabsReducer,
  inputOperationReducer,
  savedProductsReducer,
  inputReadyProductReducer,
  semiProductsReducer
}) => ({
  userReducer,
  tabsReducer,
  inputOperationReducer,
  savedProductsReducer,
  inputReadyProductReducer,
  semiProductsReducer
});
const mapDispatchToProps = {
  getOperation,
  getSemiProducts,
  saveOperation,
  loadReadyProducts,
  saveReadyProducts,
  getReadyProductsBySemi,
  modalErrorOpen,
  setSaveRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SemiProductsTable);
